import { z } from 'zod';
export const API_PREFIX = '/api/v1';
/**
 * Every resource carries its identity and a monotonic version. SSE events and
 * REST snapshots are reconciled on that version and on nothing else.
 */
export const ResourceEnvelopeSchema = z.object({
    id: z.string().min(1),
    version: z.number().int().nonnegative(),
});
export const ErrorCodeSchema = z.enum([
    'unauthenticated',
    'forbidden',
    'notFound',
    'invalidRequest',
    'conflict',
    'unavailable',
    'internal',
]);
/** The only error shape the HTTP seam ever returns. It never carries detail about why access failed. */
export const ErrorResponseSchema = z.object({
    error: z.object({ code: ErrorCodeSchema, message: z.string() }),
});
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    database: z.enum(['ok', 'unreachable']),
});
/** Header carrying the double-submit CSRF token on every state-changing request. */
export const CSRF_HEADER = 'x-csrf-token';
/** Header carrying an idempotency key on commands that cost money or branch work. */
export const IDEMPOTENCY_HEADER = 'idempotency-key';
//# sourceMappingURL=http.js.map